<script setup>
import TheMainScreen from "@/components/sections/TheMainScreen.vue";
import ThePrizes from "@/components/sections/ThePrizes.vue";
import TheGames from "@/components/sections/TheGames.vue";
import TheWinners from "@/components/sections/TheWinners.vue";
import TheFaq from "@/components/sections/TheFaq.vue";
import TheLine from "@/components/sections/TheLine.vue";

</script>
<template>
	<TheMainScreen />
	<TheGames />
 	<ThePrizes /> 
	<TheLine/>
	<TheWinners />
	<TheLine/>
	<TheFaq />
	<!-- <TheLine/> -->
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.v-enter-active,
.v-leave-active {
	transition: opacity 0.8s ease, transform 0.8s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
	transform: translateY(100%);
}
</style>
